// Models
/**
 * Synthesizes a delta-sync URL for a task's chat thread.
 *
 * The chat messages endpoint never returns an `@deltaLink` of its own — `@nextLink` is overloaded
 * to serve both pagination and delta sync. The convention is to take the latest `nextLink`, append
 * `?startTime=<oldest-loaded-message-createdDateTime-in-ms>`, and use that URL as the delta-sync
 * starting point. The startTime bounds the window so the server only emits changes for messages we
 * have actually loaded.
 *
 * Returns `null` when there is no `nextLink`, when there are no messages to anchor the window, or
 * when the `nextLink` is not a parseable URL — callers should treat that as "delta sync not yet
 * available, fall back to a full fetch."
 *
 * @param nextLink The cursor returned by the messages endpoint
 * @param existingMessages Messages already in the store (may be empty)
 * @param newMessages Messages just fetched in the current page
 */ export function calculateChatDeltaLink(nextLink, existingMessages, newMessages) {
    if (!nextLink) {
        return null;
    }
    const allMessages = [
        ...existingMessages,
        ...newMessages
    ];
    if (allMessages.length === 0) {
        return null;
    }
    const oldestMessage = allMessages.reduce((oldest, current)=>current.createdDateTime.epochMilliseconds < oldest.createdDateTime.epochMilliseconds ? current : oldest);
    const startTime = oldestMessage.createdDateTime.epochMilliseconds;
    try {
        const urlObj = new URL(nextLink);
        urlObj.searchParams.set("startTime", startTime.toString());
        return urlObj.toString();
    } catch  {
        return null;
    }
}
